import React from 'react';
import { Link } from 'react-router-dom';

const features = [
  { icon: '🤖', title: 'AI Life Coach', desc: 'OpenClaw-powered assistant die je helpt plannen, focussen en doelen bereiken', color: 'blue' },
  { icon: '📚', title: 'Free Courses', desc: 'Gratis cursussen over productiviteit, time management en ADHD coping strategies', color: 'green' },
  { icon: '💼', title: 'Career Support', desc: 'Van sollicitatie tot promotie — speciaal voor neurodivergente professionals', color: 'purple' },
  { icon: '🧠', title: 'Brain Training', desc: 'Wetenschappelijk onderbouwde oefeningen voor beter geheugen en focus', color: 'orange' },
];

const freeCourses = [
  { title: 'ADHD & Productiviteit', lessons: 8, students: '2,340', duration: '2 uur' },
  { title: 'Time Management Hacks', lessons: 6, students: '1,890', duration: '90 min' },
  { title: 'Focus Training', lessons: 10, students: '3,120', duration: '3 uur' },
];

const premiumCourses = [
  { title: 'Complete Life System', price: '€149', oldPrice: '€299', students: '542', features: ['Persoonlijke AI coach', '1-op-1 sessies', 'Levenslange toegang'] },
  { title: 'Career Accelerator', price: '€99', oldPrice: '€199', students: '328', features: ['CV optimalisatie', 'Interview training', 'Salaries onderhandeling'] },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-800 text-white py-32 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <div className="mb-6">
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 text-white px-6 py-2 rounded-full font-semibold text-sm">
              🚀 Powered by OpenClaw AI
            </span>
          </div>
          <h1 className="text-6xl md:text-7xl font-bold mb-6">Neem Controle Over Je ADHD</h1>
          <p className="text-2xl mb-8 opacity-90 max-w-3xl mx-auto">
            Gratis cursussen, AI-coaching, en een community die je begrijpt. 
            Sluit je aan bij 10.000+ mensen die hun leven hebben veranderd.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/courses" className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-10 py-5 rounded-full font-bold text-xl hover:shadow-2xl hover:scale-105 transition transform">
              Start Gratis
            </Link>
            <Link to="/ai-coach" className="border-2 border-white text-white px-10 py-5 rounded-full font-bold text-xl hover:bg-white hover:text-indigo-900 transition">
              🤖 Probeer AI Coach
            </Link>
          </div>
          <div className="mt-12 flex justify-center items-center gap-8 text-sm opacity-80">
            <span>⭐ 4.9/5 van 2,300+ reviews</span>
            <span>🔒 30 dagen geld-terug garantie</span>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold text-center mb-16 text-gray-800">Wat Je Krijgt</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {features.map((f, i) => (
              <div key={i} className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition transform hover:-translate-y-2">
                <div className="text-5xl mb-4">{f.icon}</div>
                <h3 className="text-2xl font-bold mb-3">{f.title}</h3>
                <p className="text-gray-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Free Courses */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold text-center mb-4 text-gray-800">Gratis Cursussen</h2>
          <p className="text-xl text-center text-gray-600 mb-16 max-w-2xl mx-auto">Start zonder investering. Alle gratis cursussen zijn volledig toegankelijk, forever.</p>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {freeCourses.map((c, i) => (
              <div key={i} className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-lg p-8 border-l-4 border-green-500">
                <div className="flex items-center gap-2 mb-4">
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold">GRATIS</span>
                </div>
                <h3 className="text-2xl font-bold mb-4">{c.title}</h3>
                <div className="flex justify-between text-gray-600 mb-6">
                  <span>{c.lessons} lessen</span>
                  <span>{c.duration}</span>
                </div>
                <div className="text-sm text-gray-500 mb-6">{c.students} studenten</div>
                <Link to={`/courses/free/${i}`} className="block text-center bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition">
                  Start Nu
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Premium Courses */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold text-center mb-4 text-gray-800">Premium Programma's</h2>
          <p className="text-xl text-center text-gray-600 mb-16 max-w-2xl mx-auto">Investeer in jezelf met onze uitgebreide programma's met persoonlijke begeleiding.</p>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {premiumCourses.map((c, i) => (
              <div key={i} className="bg-white rounded-2xl shadow-2xl p-8 border-2 border-purple-200 relative">
                <div className="absolute top-0 right-0 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-2 rounded-bl-2xl font-bold">
                  POPULAIR
                </div>
                <h3 className="text-3xl font-bold mb-4">{c.title}</h3>
                <div className="flex items-baseline gap-4 mb-6">
                  <span className="text-5xl font-bold text-purple-600">{c.price}</span>
                  <span className="text-xl text-gray-400 line-through">{c.oldPrice}</span>
                  <span className="text-green-600 font-semibold">50% KORTING</span>
                </div>
                <div className="text-sm text-gray-500 mb-6">{c.students} studenten ingeschreven</div>
                <ul className="space-y-3 mb-8">
                  {c.features.map((f, j) => (
                    <li key={j} className="flex items-center gap-3">
                      <span className="text-green-500">✓</span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Link to={`/courses/premium/${i}`} className="block text-center bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-4 rounded-lg font-bold text-lg hover:shadow-xl transition">
                  Start Programma
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI Coach Section */}
      <section className="py-24 bg-gradient-to-r from-indigo-900 to-purple-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="text-6xl mb-6">🤖</div>
          <h2 className="text-5xl font-bold mb-6">OpenClaw AI Coach</h2>
          <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
            Je persoonlijke AI-assistent, 24/7 beschikbaar. Helpt je plannen, herinnert je aan taken, 
            geeft advies bij uitstelgedrag, en viert je successen.
          </p>
          <Link to="/ai-coach" className="inline-block bg-white text-indigo-900 px-10 py-5 rounded-full font-bold text-xl hover:shadow-2xl transition">
            Start Gratis Sessie
          </Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold text-center mb-16 text-gray-800">Wat Mensen Zeggen</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { name: 'Sarah', text: 'De AI coach heeft mijn leven veranderd. Ik krijg eindelijk dingen gedaan!', rating: 5 },
              { name: 'Mark', text: 'Eindelijk een platform dat snapt hoe ADHD werkt. De gratis cursussen zijn goud waard.', rating: 5 },
              { name: 'Emma', text: 'Het premium programma heeft me geholpen een promotie te krijgen. Beste investering ooit.', rating: 5 },
            ].map((t, i) => (
              <div key={i} className="bg-gray-50 rounded-2xl p-8 shadow-lg">
                <div className="flex mb-4">
                  {'⭐'.repeat(t.rating)}
                </div>
                <p className="text-gray-700 mb-6 italic">"{t.text}"</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full"></div>
                  <div>
                    <div className="font-bold">{t.name}</div>
                    <div className="text-sm text-gray-500">Geverifieerde gebruiker</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-center">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold mb-6">Klaar Om Te Starten?</h2>
          <p className="text-2xl mb-8 opacity-90">Sluit je aan bij duizenden anderen die hun ADHD hebben omarmd.</p>
          <Link to="/register" className="inline-block bg-white text-green-600 px-12 py-6 rounded-full font-bold text-2xl hover:shadow-2xl transition">
            Gratis Account Aanmaken
          </Link>
        </div>
      </section>
    </div>
  );
}
